import {View} from 'MWC';
import tpl from '../templates/UsageBlock.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            showTooltip: false,
            tooltipText: '',
            tooltipElement: null
        };
        this.setTooltipState = this.setTooltipState.bind(this);
        return this;
    }

    setTooltipState(event, state, text) {
        this.setState({
            showTooltip: state,
            tooltipText: text,
            tooltipElement: event.currentTarget
        });
    }

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
